import React from "react";
import IntOutBoundFileList from "../component/intOutBoundFileList";

const IntOutBoundFileListContainer = () => (<IntOutBoundFileList />)

export default IntOutBoundFileListContainer;